import Index from "./Pages/Index";
import About from "./Pages/About";
import Portfolio from "./Pages/Portfolio";
import PortfolioDetail from "./Pages/PortfolioDetail";
import Blog from "./Pages/Blog";
import BlogDetail from "./Pages/BlogDetail";
import Communication from "./Pages/Communication";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Certificates from "./Pages/Certificates";
function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/Blog" element={<Blog />} />
          <Route path="/Portfolio" element={<Portfolio />} />
          <Route path="/Certificates" element={<Certificates />} />
          <Route path="/Communication" element={<Communication />} />
          <Route path="/About" element={<About />} />
          <Route
            path="/BlogDetail/:id"
            element={
                <BlogDetail />
            }
          />
          <Route
            path="/PortfolioDetail/:id"
            element={
                <PortfolioDetail />
            }
          />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
